import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickSmallPendingLight({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#FFE6CE" cx={8} cy={8} r={8} />
        <path
          d="M5 7c.28 0 .5.22.5.5v1A.5.5 0 015 9H4a.5.5 0 01-.5-.5v-1c0-.28.22-.5.5-.5h1zm3.5 0c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1c0-.28.22-.5.5-.5h1zM12 7c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1c0-.28.22-.5.5-.5h1z"
          fill="#FB8F23"
        />
      </g>
    </svg>
  );
}

SvgTickSmallPendingLight.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickSmallPendingLight.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgTickSmallPendingLight svgRef={ref} {...props} />
));
export default ForwardRef;
